const NAV_LINKS = [
  { id: 'today', label: '今日爆料榜' },
  { id: 'celebrity', label: '明星绯闻' },
  { id: 'influencer', label: '网红黑料' },
  { id: 'timeline', label: '吃瓜时间线' },
];

const MORE_LINKS = [
  { id: 'featured', label: '吃瓜精选' },
  { id: 'channels', label: '爆料频道' },
  { id: 'faq', label: '常见问题' },
  { id: 'subscribe', label: '订阅爆料' },
];

export default function SiteFooter() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black tracking-wide text-background-50">爆料网</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-md">
              每天集中整理网红黑料、明星绯闻与热门吃瓜事件，标注已知信息与待核实部分，帮你在信息过载的时代快速看清今天真正值得关注的话题。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white/10 text-xs text-background-100">
                <i className="ri-time-line"></i> 每日 3 次集中更新
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white/10 text-xs text-background-100">
                <i className="ri-shield-check-line"></i> 标注信息来源
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">热门分区</h3>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => goTo(link.id)}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">更多</h3>
            <ul className="space-y-2.5">
              {MORE_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => goTo(link.id)}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} 爆料网 · 内容为公开信息整理，仅供参考，不构成任何事实认定
          </p>
          <p className="text-xs text-background-300">理性吃瓜 · 尊重当事人 · 不信谣不传谣</p>
        </div>
      </div>
    </footer>
  );
}